<h2 mat-dialog-title>Asset ownership</h2>
<div mat-dialog-content class="asset-results">
  @if (loading) { <mat-progress-bar mode="indeterminate"></mat-progress-bar> }
  @if (response.message) { <p class="asset-response-message">{{ response.message }}</p> }
  @for (group of [{title: 'Created assets', assets: response.createdAssets}, {title: 'Existing assets', assets: response.existingAssets}]; track group.title) {
    @if (group.assets?.length) {
      <h3>{{ group.title }}</h3>
      @for (asset of group.assets; track asset.id) {
        <section class="ownership-asset">
          <div class="ownership-heading">
            <strong>{{ asset.name }}</strong>
            <div>
              <button mat-icon-button (click)="navigateToAsset(asset)" aria-label="View asset" matTooltip="View asset"><mat-icon>search</mat-icon></button>
              <button mat-icon-button (click)="pullOwnership(asset)" aria-label="Refresh ownership history" matTooltip="Refresh ownership history"><mat-icon>history</mat-icon></button>
            </div>
          </div>
          @if (asset.history?.length) {
            @if (asset.openForAssignment === false && asset.isHealthSensor === false) {
              <button mat-stroked-button class="ownership-remove" (click)="deleteDialog(asset, asset.history[0].customerName)">Remove asset ownership</button>
            }
            @if (asset.openForAssignment && asset.isHealthSensor === false) {
              <button mat-stroked-button class="ownership-assign" (click)="navigateToDialog(asset)">Assign to customer</button>
            }
            <div class="ownership-history">
              @for (history of asset.history; track history.id) {
                <button mat-button class="ownership-history-link" [class.current-ownership]="history.whenEnd === null" (click)="navigateToCustomer(history)">
                  <span class="ownership-customer">{{ history.customerName }}</span>
                  <span class="ownership-dates">{{ history.whenBegin | date: 'short' }} — {{ history.whenEnd ? (history.whenEnd | date: 'short') : 'Current' }}</span>
                </button>
              }
            </div>
          }
          @if (asset.noOwnership) {
            <p class="ownership-empty">No ownership history</p>
            @if (!asset.isHealthSensor) {
              <button mat-stroked-button class="ownership-assign" (click)="navigateToDialog(asset)">Assign to customer</button>
            }
          }
        </section>
      }
    }
  }
</div>
<div mat-dialog-actions align="end"><button mat-flat-button class="ownership-done" (click)="okayClick()">Done</button></div>
